// extracted by mini-css-extract-plugin
export default {"wrap":"FormItem_wrap__U3r9g","fullWidth":"FormItem_fullWidth__G3ZWP"};